import React from 'react';
import { cn } from '@/lib/cn';

type FormGridColumns = 1 | 2 | 3;
type FormGridGap = 'sm' | 'md' | 'lg';

export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Colunas em telas largas (>=640px). Colapsa para 1 no mobile. Default 1. */
  columns?: FormGridColumns;
  /** Espacamento entre os campos (tokens --s-*). Default 'md'. */
  gap?: FormGridGap;
}

const COLUMNS_CLASS: Record<FormGridColumns, string> = {
  1: '',
  2: 'form-grid--cols-2',
  3: 'form-grid--cols-3',
};

const GAP_CLASS: Record<FormGridGap, string> = {
  sm: 'form-grid--gap-sm',
  md: '',
  lg: 'form-grid--gap-lg',
};

/**
 * Grade responsiva de campos de formulario. Empilha em 1 coluna no mobile e
 * abre em N colunas (>=640px); o gap (por token) da o respiro consistente entre
 * os campos. Generica e aninhavel - use para empilhar campos e para linhas de
 * 2-3 campos lado a lado, sem markup de grid cru na tela.
 */
export function FormGrid({
  columns = 1,
  gap = 'md',
  className,
  ...props
}: FormGridProps) {
  return (
    <div
      className={cn('form-grid', COLUMNS_CLASS[columns], GAP_CLASS[gap], className)}
      {...props}
    />
  );
}
